// Generated from App.tsx for a single page build. Do not edit.
// Generated by the server from the registered pages. Do not edit.
import { Routes, Route, useLocation } from 'react-router-dom';
import HiddenShowreelPage from "../pages/HiddenShowreel/HiddenShowreel";
const __wvcRoutePaths = ["/HiddenShowreelPage"];
function AppRoutes() {
  const location = useLocation();
  const owned = new Set(["hiddenshowreelpage", "home", "homepage", "portfolio", "portfoliopage", "post", "testimonials", "testimonialspage", "video", "videopage"]);
  const segment = (location.pathname.split('/')[1] || '').toLowerCase();
  return <Routes key={owned.has(segment) ? segment : '/'}>
      
      
      
      
      <Route path={__wvcRoutePaths[0]} element={<HiddenShowreelPage />} />
      
      
      
      
      
      
    </Routes>;
}
function App() {
  return <>
      <AppRoutes />
    </>;
}
export default App;
